export const today = new Date();

export const aMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

export const aWeekAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
